import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxMaskModule } from 'ngx-mask'
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatStepperModule } from '@angular/material/stepper';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from "@angular/material/form-field";

import { PublicRoutingModule } from './public-routing.module';
import { ExternalPageModule } from '../../shared/components/external-page/external-page.module';
import { PublicComponent } from './public.component';
import { InternalPageComponent } from './internal-page/internal-page.component';
import { ClinicsComponent } from './clinics/clinics.component';
import { SelectableCardModule } from '../../shared/components/selectable-card/selectable-card.module';
import { TypesComponent } from './types/types.component';
import { IconCircleModule } from '../../shared/components/icon-circle/icon-circle.module';
import { DentistsComponent } from './dentists/dentists.component';
import { AvailableHoursComponent } from './available-hours/available-hours.component';
import { SummaryComponent } from './summary/summary.component';
import { SummaryTermsComponent } from './summary-terms/summary-terms.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { InvalidTimeDialogComponent } from './invalid-time-dialog/invalid-time-dialog.component';
import { ErrorPageModule } from '../../shared/components/error-page/error-page.module';
import { PageNotFoundModule } from '../../shared/components/page-not-found/page-not-found.module';

@NgModule({
  declarations: [
    PublicComponent,
    InternalPageComponent,
    ClinicsComponent,
    TypesComponent,
    DentistsComponent,
    AvailableHoursComponent,
    SummaryComponent,
    SummaryTermsComponent,
    ConfirmationComponent,
    InvalidTimeDialogComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PublicRoutingModule,
    ExternalPageModule,
    FlexLayoutModule,
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatSelectModule,
    MatChipsModule,
    MatInputModule,
    MatCheckboxModule,
    MatStepperModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    NgxMaskModule,
    SelectableCardModule,
    IconCircleModule,
    ErrorPageModule,
    PageNotFoundModule
  ]
})
export class PublicModule { }
